var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9781 2.38977L1.87891 3.47103L16.0236 17.3898L17.1228 16.3082L2.9781 2.38977Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20032 5.75606L5.23492 6.77411C4.10236 7.723 3.20051 8.90414 2.61773 9.93755L2.61595 9.94104C4.23901 12.6114 6.81431 15.135 10.0647 14.7522C10.942 14.6488 11.7605 14.3537 12.5083 13.9315L13.5557 14.9618C12.098 15.8824 10.4271 16.3699 8.6166 16.1289C5.35204 15.6945 2.68268 13.0598 1 9.96549C1.79005 8.40123 2.87079 6.90472 4.20032 5.75606ZM6.55345 4.24733C7.4663 3.8471 8.45405 3.61171 9.50887 3.59494C9.56744 3.59459 10.2627 3.62707 10.5779 3.67806C10.7756 3.71019 10.9726 3.75036 11.1667 3.8003C14.2634 4.59413 16.5576 7.17015 18 9.82405C17.3949 11.0265 16.6023 12.1999 15.6572 13.2054L14.6538 12.2181C15.3519 11.4777 15.934 10.6535 16.3823 9.85408C16.3823 9.85408 15.9315 9.14093 15.5897 8.6932C15.37 8.40542 15.139 8.12603 14.8962 7.85676C14.7046 7.64442 13.9603 6.92323 13.7832 6.77306C12.5949 5.76759 11.1997 4.97865 9.52626 4.99192C8.87818 5.00204 8.25494 5.12777 7.66328 5.33941L6.55345 4.24733Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01632 8.52776L7.81499 9.31334L10.8892 12.3384C10.4782 12.5654 10.004 12.6946 9.4997 12.6946C7.92917 12.6946 6.6543 11.4401 6.6543 9.8947C6.6543 9.39843 6.78597 8.93219 7.01632 8.52776ZM9.44717 7.09552C9.46456 7.09517 9.48231 7.09482 9.4997 7.09482C11.0702 7.09482 12.3451 8.34965 12.3451 9.8947C12.3451 9.91216 12.3451 9.92928 12.3447 9.94639L9.44717 7.09552Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3e42a97324de1f899efeab23743191fa.svg";
export { ForwardRef as ReactComponent };